import { Link } from "react-router-dom";
import { Plus, Terminal } from "lucide-react";

export function EmptyState() {
  return (
    <div className="border border-dashed border-ink-700 bg-ink-900/40 py-20 px-8 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-[0.04] bg-[linear-gradient(to_right,currentColor_1px,transparent_1px),linear-gradient(to_bottom,currentColor_1px,transparent_1px)] bg-[size:32px_32px] text-phosphor-400" />
      <div className="relative flex flex-col items-start max-w-lg">
        <div className="inline-flex items-center gap-2 text-phosphor-400 mb-5">
          <Terminal size={16} />
          <span className="term-label">stdout / empty</span>
        </div>
        <h2 className="font-serif text-4xl text-ink-100 leading-[1.05] mb-3">
          No sandboxes <em className="text-phosphor-400">provisioned.</em>
        </h2>
        <p className="text-ink-400 text-sm leading-relaxed mb-6 max-w-md">
          Spin up an ephemeral Postgres database from a natural-language prompt.
          Seeded in seconds. Destroyed on schedule. No leftovers.
        </p>
        <Link to="/new" className="btn btn-primary">
          <Plus size={14} />
          new sandbox
        </Link>
        <pre className="mt-10 text-[10px] text-ink-500 leading-tight select-none">
{`# try it:
$ simdb create --prompt "ecommerce with 50 users, 200 orders"
→ postgresql://...`}
        </pre>
      </div>
    </div>
  );
}
